export default "__VITE_ASSET__Crixxe02__"